const hideOtherButtons = () => {
  const amazonPayButton = document.querySelector("form[action='https://payments-fe.amazon.com/checkout/signin']")?.parentElement ?? null
  const dynamicCheckoutButtons = amazonPayButton?.parentElement?.children ?? null

  if (!dynamicCheckoutButtons) {
    setTimeout(() => {
      hideOtherButtons()
    }, 10)
    return
  }
  
  Array.from(dynamicCheckoutButtons).forEach((dynamicCheckoutButton) => {
    if (dynamicCheckoutButton === amazonPayButton) {
      return
    }
    dynamicCheckoutButton.style.display = 'none'
  })
}

const showProducts = (items, currency) => {
  items.forEach((item) => {
    const image = item.featured_image?.url ?? ''
    const title = item.title
    const quantity = item.quantity
    const finalLinePrice = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: currency })
      .format(Math.round(item.final_price / 100))

    const div = document.createElement('div')
    div.className = 'kau__amazon__pay__orders__product'

    const innerHTML = `
<div class="kau__amazon__pay__orders__product__image">
  <img
    class="kau__amazon__pay__orders__product__image__img"
    src="${image}"/>
</div>
<div class="kau__amazon__pay__orders__product__desc">
  <div>
    <p class="kau__amazon__pay__orders__product__desc__title kau__bold">${title}</p>
    <p class="kau__amazon__pay__orders__product__desc__quantity">数量: ${quantity}</p>
  </div>
  <div class="kau__amazon__pay__orders__product__desc__price">${finalLinePrice}</div>
</div>`

    const productWrapper = document.getElementById("kau__amazon__pay__orders__products")

    div.innerHTML = innerHTML

    productWrapper.appendChild(div)
  })
}

const showOrder = (cart) => {
  // cent to JYP -> 1/100
  const subTotal = cart.items_subtotal_price
    ? new Intl.NumberFormat('ja-JP', { style: 'currency', currency: cart.currency })
      .format(Math.round(cart.items_subtotal_price / 100))
    : '&yen;0'

  const total = cart.total_price
    ? new Intl.NumberFormat('ja-JP',{ style: 'currency',currency: cart.currency })
      .format(Math.round(cart.total_price / 100))
    : '&yen;0'

  const subTotalDom = document.getElementById("kau__amazon__pay__orders__subtotal")
  const totalDom = document.getElementById("kau__amazon__pay__orders__total")

  subTotalDom.innerHTML = subTotal
  totalDom.innerHTML = total
}

hideOtherButtons()

window.addEventListener('DOMContentLoaded', () => {
  const kauAmazonPayButton = document.getElementById("kau-amazon-pay-button")
  const kauAmazonPayButtonDisabled = document.getElementById("kau-amazon-pay-button-disabled")
  const policyCheckbox = document.getElementById("policy_checkbox")
  policyCheckbox.addEventListener('change', () => {
    if (policyCheckbox.checked) {
      kauAmazonPayButton.style.display = "table"
      kauAmazonPayButtonDisabled.style.display = "none"
    } else {
      kauAmazonPayButton.style.display = "none"
      kauAmazonPayButtonDisabled.style.display = "block"
    }
  })
})

const query = new URLSearchParams(window.location.search)
const items = decodeURI(query.get('items'))
const metafield = decodeURI(query.get('metafield'))

fetch(`${window.Shopify.routes.root}cart/clear.js`, {
  method: "POST",
  headers: {
      "Content-Type": "application/json",
  }
})
.then((res) => res.json())
.then((data) => {
  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
    },
    body: items
  })
  .then((res) => res.json())
  .then((data) => {
      fetch(`${window.Shopify.routes.root}cart.js`)
        .then(res => res.json())
        .then(data => {
          showProducts(data.items, data.currency)
          showOrder(data)

          fetch("https://guw9oepuq7.execute-api.ap-northeast-1.amazonaws.com/Stage/spark-backend/amazonPay", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              "id": "",
              "store": 37,
              "cart_token": data.token,
              "metafield": JSON.parse(metafield),
              "created_at": new Date(),
              "captured_at": null
            })
          })
        });
  }).catch((err) => {
    console.error(err)
  })
})